import { Theme } from "@mui/material";
import { IFormDateRange } from "../../../services/custom-forms-data-service/TemplateModels";
import FormDateRange from "../../forms/form-date-range/FormDateRange";
import FormProperty from "../../forms/form-property/FormProperty";
import { SxProps } from "@mui/system";

export type CustomFormDateRangeProps = {
    dateRange: IFormDateRange;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};

export default function CustomFormDateRange({
    dateRange,
    key,
    sx
}: CustomFormDateRangeProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormDateRange name={dateRange.name} readOnly={dateRange.readOnly} />
        </FormProperty>
    );
}
